import { render, staticRenderFns } from "./liveManage.vue?vue&type=template&id=0465d7c2&scoped=true"
import script from "./liveManage.vue?vue&type=script&lang=js"
export * from "./liveManage.vue?vue&type=script&lang=js"
import style0 from "./liveManage.vue?vue&type=style&index=0&id=0465d7c2&prod&lang=stylus&scoped=true"
import style1 from "./liveManage.vue?vue&type=style&index=1&id=0465d7c2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0465d7c2",
  null
  
)

export default component.exports